module.exports = __webpack_public_path__ + "media/testimonials/property-2-a2c3a641.jpg";